/**
 * Magnetic Component
 *
 * Transforms elements into magnetic buttons and initializes behavior.
 * This must be imported AFTER any blocks that create elements.
 */

import { prepareMagneticButtons } from '../utils/magnetic-markup';
import MagneticButtons from '../utils/magnetic-buttons';

let magneticInstance = null;

function initMagnetic() {
	// ============================================
	// Transform elements into magnetic structure
	// ============================================

	// Note: Portfolio card headings are handled by animated-sections.js
	// which adds both the animated chars AND magnetic structure.

	// Navigation submenu toggles (standalone buttons)
	prepareMagneticButtons('.site-logo', {
		type: 'link',
		strength: 24,
		strengthText: 12,
	});

	// WordPress buttons - adds fill effect
	prepareMagneticButtons('.wp-block-button:not(.is-style-link)', {
		type: 'button',
		strength: 50,
		strengthText: 25,
	});

	// Read more links (standalone anchors)
	prepareMagneticButtons('.wp-block-read-more', {
		type: 'link',
		strength: 24,
		strengthText: 12,
	});

	// Read more links (standalone anchors)
	prepareMagneticButtons('.wp-block-navigation-item__content', {
		type: 'link',
		strength: 24,
		strengthText: 12,
	});

	// Navigation submenu toggles (standalone buttons)
	prepareMagneticButtons('.wp-block-navigation-submenu__toggle', {
		type: 'link',
		strength: 24,
		strengthText: 12,
	});

	prepareMagneticButtons('.contact-aside a', {
		type: 'link',
		strength: 24,
		strengthText: 12,
	});

	prepareMagneticButtons('.site-footer .wp-social-link', {
		type: 'link',
		strength: 24,
		strengthText: 12,
	});

	// Note: The hamburger is created by blocks/navigation.js with
	// magnetic classes already applied, so we don't need to transform it here.

	// ============================================
	// Initialize magnetic behavior on all .magnetic elements
	// ============================================
	magneticInstance = new MagneticButtons();

	// Store globally for access if needed
	window.magneticButtons = magneticInstance;
}

/**
 * Refresh magnetic buttons (call after adding new .magnetic elements)
 */
function refreshMagnetic() {
	if (magneticInstance) {
		magneticInstance.refresh();
	} else {
		initMagnetic();
	}
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initMagnetic);
} else {
	initMagnetic();
}

export { initMagnetic, refreshMagnetic, prepareMagneticButtons };
